import { render } from "./Scadenzario.vue?vue&type=template&id=db151b96"
import script from "./Scadenzario.vue?vue&type=script&lang=js"
export * from "./Scadenzario.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__